import {
  getAllIvsEventByLicenseAsync,
  getAllIvsEventCountByLicenseAsync,
  getIvsEventByIdAsync,
} from '../../index';
import { useMutation } from 'react-query';

export const useGetIvsEventByIdAsync = () => useMutation(getIvsEventByIdAsync);

export const useGetAllIvsEventByLicenseAsync = () =>
  useMutation(getAllIvsEventByLicenseAsync);

export const useGetAllIvsEventByLicenseCountAsync = () =>
  useMutation(getAllIvsEventCountByLicenseAsync);
